import { render, staticRenderFns } from "./bet-history-charts.vue?vue&type=template&id=9e6845d4&scoped=true"
import script from "./bet-history-charts.vue?vue&type=script&lang=js"
export * from "./bet-history-charts.vue?vue&type=script&lang=js"
import style0 from "./bet-history-charts.vue?vue&type=style&index=0&id=9e6845d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6845d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e6845d4')) {
      api.createRecord('9e6845d4', component.options)
    } else {
      api.reload('9e6845d4', component.options)
    }
    module.hot.accept("./bet-history-charts.vue?vue&type=template&id=9e6845d4&scoped=true", function () {
      api.rerender('9e6845d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tai-xiu/bet-history-charts.vue"
export default component.exports